import React from 'react';
import FeedCostAnalysis from '../FeedCostAnalysis';
import NutritionalReportsHub from '../NutritionalReportsHub';
import FeedStockAnalyticsPane from '../FeedStockAnalyticsPane';
import NutritionTrendsPanel from './NutritionTrendsPanel';
import type { NutritionReportsView } from './nutritionManagementNav';
import { NutritionalAnalytics, NutritionalTrendData } from '../../api/nutrition';

interface NutritionReportsPanelProps {
  view: NutritionReportsView;
  selectedLocation: string;
  dateRange: { startDate: string; endDate: string };
  trends: { data: NutritionalTrendData[]; analytics: NutritionalAnalytics } | null;
  onReportGenerated: () => void;
}

export default function NutritionReportsPanel({
  view,
  selectedLocation,
  dateRange,
  trends,
  onReportGenerated,
}: NutritionReportsPanelProps) {
  if (view === 'cost') {
    return <FeedCostAnalysis selectedLocation={selectedLocation} dateRange={dateRange} />;
  }

  if (view === 'inventory') {
    return <FeedStockAnalyticsPane />;
  }

  return (
    <div className="space-y-6">
      {trends && trends.data.length > 0 && (
        <NutritionTrendsPanel trends={trends} chartInstanceKey="reports-nutritional" />
      )}
      <NutritionalReportsHub selectedLocation={selectedLocation} onReportGenerated={onReportGenerated} />
    </div>
  );
}
